export const getBrandUnit = brand => brand?.toLowerCase() === 'kbb' ? 'my-kbb' : 'my-at';
export default getBrandUnit;